import React from "react";
import { Col, Container, Ratio, Row } from "react-bootstrap";
import './Artist-card.css'

const VideoBlock = ({videoID}) => {
	return (
		<Col xs={12}>
			<div style={{ width: '100%', height: 'auto' }} className='video-responsive'>
				<Ratio aspectRatio="16x9">
					<iframe				
					src={`https://www.youtube.com/embed/${videoID}`}
					title="La Vitrine - Projet Iliens "
					frameBorder="0"
					allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
					allowFullScreen
				></iframe>
				</Ratio>
			</div>
		</Col>
		// <Col xs={12}>
		// 	<div className="video-responsive">	
		// 	<iframe
		// 		width="450"
		// 		height="315"
		// 		src={`https://www.youtube.com/embed/${videoID}`}
		// 		title="YouTube video player"
		// 		frameBorder="0"
		// 		allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
		// 		allowFullScreen
		// 	></iframe>
		// 	</div>
		// </Col>
	);
};

const TextBlock = ({title, content}) => {
	return (
		<Col xs={12}>
			<h2 className="title-artist my-5 mx-0">{title}</h2>
			<div className="desc-artist pb-5"
			dangerouslySetInnerHTML={{
				__html: content
			}}></div>			
		</Col>		
	);
};

const ArtistCard = ({ video, titre, description, reverse = false }) => {

	const idVideo = "2sQideyXd4M";
	const title = "Artist";
	const content = "<p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ad ipsum vero, odit delectus amet, impedit dolorem corrupti ipsa reiciendis sed officiis a, sint iure eveniet illum tempore nostrum tenetur at facere? Ipsam velit possimus, maiores molestiae iste eius quibusdam veritatis vero obcaecati odit est, provident voluptate vel accusantium laudantium similique!</p><p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta, amet?</p><p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Sit ea nihil,quia deserunt laudantium assumenda vel, fugit quam nam inventore veniam.Excepturi laborum officiis fuga?</p>";
	
	return (
		<Container>
			<Row>		
				{(reverse) ? <TextBlock title={titre} content={description} /> : <VideoBlock  videoID={video} />}
				{(reverse) ? <VideoBlock videoID={video} /> : <TextBlock title={titre} content={description} />}		
			</Row>
		</Container>
	);
};

export default ArtistCard;
